<template>
  <v-container>
    <!-- -------------------------------------------- ||CARD|| ---------------------------------------------------->
    <v-card class="card rounded-xl mb-10" elevation="1">
      <v-container>
        <div class="mt-5">
          <div class="result6"><h3 class="header">ລາງວັນເລກ 6 ໂຕ</h3></div>
          <div class="result6">
            <p class="white--text">
              ຊື້ຖືກ 1000 ກີບ ໄດ້ຮັບເງິນສົດ 400,000,000 ກີບ
            </p>
          </div>
          <div class="result6">
            <img src="../../assets/icon/vital_signs icon.svg" />
          </div>
          <div class="result6">
            <v-avatar
              v-if="this.result6[1]?.winNumber[0]"
              class="mx-1 fontStyle"
              color="white"
              elevation="2"
              >{{ this.result6[1]?.winNumber[0] || "-" }}</v-avatar
            >
            <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
            <v-avatar
              v-if="this.result6[1]?.winNumber[1]"
              class="mx-1 fontStyle"
              color="white"
              elevation="2"
              >{{ this.result6[1]?.winNumber[1] || "-" }}</v-avatar
            >
            <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
            <v-avatar
              v-if="this.result6[1]?.winNumber[2]"
              class="mx-1 fontStyle"
              color="white"
              elevation="2"
              >{{ this.result6[1]?.winNumber[2] || "-" }}</v-avatar
            >
            <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
            <v-avatar
              v-if="this.result6[1]?.winNumber[3]"
              class="mx-1 fontStyle"
              color="white"
              elevation="2"
              >{{ this.result6[1]?.winNumber[3] || "-" }}</v-avatar
            >
            <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
            <v-avatar
              v-if="this.result6[1]?.winNumber[4]"
              class="mx-1 fontStyle"
              color="white"
              elevation="2"
              >{{ this.result6[1]?.winNumber[4] || "-" }}</v-avatar
            >
            <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
            <v-avatar
              v-if="this.result6[1]?.winNumber[5]"
              class="mx-1 fontStyle"
              color="white"
              elevation="2"
              >{{ this.result6[1]?.winNumber[5] || "-" }}</v-avatar
            >
            <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
          </div>
        </div>

        <v-row class="mt-10">
          <v-col>
            <div>
              <div class="result6"><h3 class="header">ລາງວັນເລກ 5 ໂຕ</h3></div>
              <div class="result6">
                <p class="white--text">
                  ຊື້ຖືກ 1000 ກີບ ໄດ້ຮັບເງິນສົດ 40,000,000 ກີບ
                </p>
              </div>

              <div class="result6">
                <v-avatar
                  v-if="this.result6[1]?.winNumber[1]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[1] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[2]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[2] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[3]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[3] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[4]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[4] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[5]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[5] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
              </div>
            </div>
          </v-col>
          <v-col>
            <div>
              <div class="result6"><h3 class="header">ລາງວັນເລກ 4 ໂຕ</h3></div>
              <div class="result6">
                <p class="white--text">
                  ຊື້ຖືກ 1000 ກີບ ໄດ້ຮັບເງິນສົດ 5,000,000 ກີບ
                </p>
              </div>

              <div class="result6">
                <v-avatar
                  v-if="this.result6[1]?.winNumber[2]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[2] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[3]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[3] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[4]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[4] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[5]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[5] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-10 mb-10">
          <v-col>
            <div>
              <div class="result6"><h3 class="header">ລາງວັນເລກ 3 ໂຕ</h3></div>
              <div class="result6">
                <p class="white--text">
                  ຊື້ຖືກ 1000 ກີບ ໄດ້ຮັບເງິນສົດ 500,000 ກີບ
                </p>
              </div>

              <div class="result6">
                <v-avatar
                  v-if="this.result6[1]?.winNumber[3]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[3] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[4]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[4] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="this.result6[1]?.winNumber[5]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[5] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div>
              <div class="result6"><h3 class="header">ລາງວັນເລກ 2 ໂຕ</h3></div>
              <div class="result6">
                <p class="white--text">
                  ຊື້ຖືກ 1000 ກີບ ໄດ້ຮັບເງິນສົດ 60,000 ກີບ
                </p>
              </div>

              <div class="result6">
                <v-avatar
                  v-if="this.result6[1]?.winNumber[4]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[4] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
                <v-avatar
                  v-if="result6[1]?.winNumber[5]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[5] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
              </div>
            </div>
          </v-col>
          <v-col>
            <div>
              <div class="result6"><h3 class="header">ລາງວັນເລກ 1 ໂຕ</h3></div>
              <div class="result6">
                <p class="white--text">
                  ຊື້ຖືກ 1000 ກີບ ໄດ້ຮັບເງິນສົດ 6,000 ກີບ
                </p>
              </div>

              <div class="result6">
                <v-avatar
                  v-if="result6[1]?.winNumber[5]"
                  class="mx-1 fontStyle"
                  color="white"
                  elevation="2"
                  >{{ this.result6[1]?.winNumber[5] }}</v-avatar
                >
                <v-avatar v-else class="mx-1 fontStyle" color="white" elevation="2">
              <v-progress-circular
                indeterminate
                color="error"
              ></v-progress-circular>
            </v-avatar>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
// import moment from "moment";
import { mapActions, mapGetters } from "vuex";
// import { genSignature } from "@/plugins/gen";

export default {
  data() {
    return {
      winNumber: "",
      response: "",
    };
  },

  computed: {
    ...mapGetters("main_result6", ["result6", "textt"]),
  },

  methods: {
    ...mapActions("main_result6", ["MainResult"]),
  },
  async mounted() {
    // console.log(
    //   'Result6 Sg',
    //   await genSignature('/api/v1/website/laolot/WinPrizeHistory?type=1')
    // );

    await this.MainResult();
  },
  destroyed() {
    window?.removeEventListener("resize", this.myEventHandlerResizeScreen);
  },
};
</script>

<style scoped>
.fontStyle {
  font-size: 20pt;
  font-weight: bold;
  color: #9e1c20;
}
.result6 {
  display: flex;
  justify-content: center;
}
.header {
  color: #ffc308;
}
.card {
  background-image: url("../../assets/INSEE_PATTERN_FOR CARD.jpg");
}
.btn {
  color: white;
}
</style>
